import * as WordsActionCreaters from './words'

export default {
  ...WordsActionCreaters,
}
